/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Inspector_SelectInputs */

const cs_pipelines_inspector_select = /** @type {(inputs: Pipelines_Inspector_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klepněte pro úpravu`)
};

const en_pipelines_inspector_select = /** @type {(inputs: Pipelines_Inspector_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to edit`)
};

/**
* | output |
* | --- |
* | "Tap to edit" |
*
* @param {Pipelines_Inspector_SelectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_inspector_select = /** @type {((inputs?: Pipelines_Inspector_SelectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Inspector_SelectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_inspector_select(inputs)
	return cs_pipelines_inspector_select(inputs)
});